import axios from "./AxiosWrapper";
import config from "../config";

const CharityServices = {
  getCharityLike(orderId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config("API_URL")}likes/charity-like`, {
          params: {
            orderId
          }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  toggleChatiryLike(orderId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}likes/toggle-like`, {
          params: {
            orderId
          }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default CharityServices;
